import { cloneDeep, isEmpty } from 'lodash';

import Box from '@mui/material/Box';
import { CaptionedComponent } from '../../models/LessonComponent';
import { InlineQuillEdit } from '../InlineQuillEdit';
import LessonComponentService from '../../services/LessonComponentService';
import { LessonContextConsumer } from '../../models/LessonContext';
import React from 'react';
import styles from '../../styles/WithCaption.module.css';
import { useLessonEditContext } from '../../models/LessonEditContext';
import useThemes from '../../../shared/hooks/useThemes';

interface WithCaptionProps {
  children: JSX.Element;
  component: CaptionedComponent;
}

export function WithCaption(props: WithCaptionProps) {
  const { handleSettingsChange } = useLessonEditContext();
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;

  function handleChange(value: string) {
    const copy = cloneDeep(props.component);
    copy.content.caption = value;
    handleSettingsChange(copy);
  }

  const component = props.component;

  const captionText = LessonComponentService.getFilteredContent(
    component.content.caption
  ); /* Preview can be displayed before saving into db. so removing linespace for the preview display */

  return (
    <LessonContextConsumer>
      {({ mode }) => (
        <div
          className={styles.captionComponentContainer}
          style={{ fontFamily }}
        >
          {props.children}
          {mode === 'edit' ? (
            <Box className={styles.captionTextContainer}>
              <InlineQuillEdit
                value={component.content.caption}
                componentKey={component.componentkey}
                styleType={'p'}
                placeholder={'Click to edit caption'}
                onChange={handleChange}
              />
            </Box>
          ) : (
            !isEmpty(captionText) && (
              <Box className={styles.captionTextContainer}>
                <span
                  className="ql-editor"
                  dangerouslySetInnerHTML={{
                    __html: LessonComponentService.getUrlWithSas(captionText)
                  }} //* content.text has been sanitized before storing into db.
                ></span>
              </Box>
            )
          )}
        </div>
      )}
    </LessonContextConsumer>
  );
}
